/**
 * src/api/admin.js
 *
 * API calls for the Admin tab's Skills Settings panel. Backed by gaussiq-admin's
 * /admin/settings/skills routes (see AdminSkillsTab.jsx). Insight Selection lives in
 * src/api/insights.js — those endpoints moved to gaussiq-intelligence, which owns the
 * insights_jobs table. User Management lives in src/api/security.js — those endpoints
 * are on gaussiq-identity, which owns users/rights.
 */

import { authedJson } from './http'

const apiGet = path => authedJson('GET', path)
const apiPatch = (path, body) => authedJson('PATCH', path, body)

// ---------------------------------------------------------------------------
// Skills Settings
// ---------------------------------------------------------------------------

/**
 * GET /admin/settings/skills
 * @returns {Promise<{orgSkillTemperature: number, individualEvidenceThreshold: number,
 *   autoApproveOrgSkills: boolean, autoApproveIndividualSkills: boolean, maxTicketAssignment: number}>}
 */
export async function fetchSkillSettings() {
  return apiGet('/admin/settings/skills')
}

/**
 * PATCH /admin/settings/skills — send only the keys that changed (all optional).
 * Returns the full, freshly-saved settings object.
 */
export async function saveSkillSettings(settings) {
  return apiPatch('/admin/settings/skills', settings)
}
